(() => {
  const roots = document.querySelectorAll('[data-frame-photo-upload]');

  roots.forEach((root) => {
    if (root.dataset.initialized === 'true') return;

    const form = document.getElementById(root.dataset.productFormId);
    if (!form) {
      const summary = root.querySelector('#frame-upload-summary');
      if (summary) summary.textContent = 'Photo upload is still loading. Refresh the page if this message remains.';
      return;
    }

    root.dataset.initialized = 'true';
    form.enctype = 'multipart/form-data';

    const input = root.querySelector('input[type="file"][data-frame-photo]');
    const authorization = root.querySelector('[data-photo-authorization]');
    const formComponent = form.closest('product-form-component');
    const validTypes = new Set(['image/jpeg', 'image/png']);
    const validExtensions = /\.(jpe?g|png)$/i;
    let previewObjectUrl = '';

    const getAddButtons = () =>
      Array.from(formComponent?.querySelectorAll('[name="add"], [ref="addToCartButton"]') || []);

    const uploadReady = () =>
      input?.dataset.photoValid === 'true' && authorization?.checked === true;

    const updateAddButtons = () => {
      const ready = uploadReady();
      const summary = root.querySelector('#frame-upload-summary');

      getAddButtons().forEach((button) => {
        if (!ready) {
          button.classList.add('frame-upload-locked');
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('aria-describedby', 'frame-upload-summary');
        } else {
          button.classList.remove('frame-upload-locked');
          button.removeAttribute('aria-disabled');
          button.removeAttribute('aria-describedby');
        }
      });

      if (summary) {
        summary.textContent = ready
          ? 'Your photo is ready and authorization is confirmed.'
          : 'Add to Cart is blocked until a valid photograph and authorization are provided.';
      }

      root.classList.toggle('frame-photo-upload--ready', ready);
    };

    const setFieldState = (state, message, previewUrl = '') => {
      const field = input?.closest('[data-photo-field]');
      const status = field?.querySelector('[data-photo-status]');
      const preview = field?.querySelector('[data-photo-preview]');

      if (input) input.dataset.photoValid = state === 'valid' || state === 'warning' ? 'true' : 'false';
      field?.setAttribute('data-state', state);
      if (status) status.textContent = message;

      if (preview) {
        if (previewUrl) {
          preview.src = previewUrl;
          preview.hidden = false;
        } else {
          preview.removeAttribute('src');
          preview.hidden = true;
        }
      }

      updateAddButtons();
    };

    const validateImage = () => {
      const file = input?.files?.[0];
      input?.setCustomValidity('');

      if (previewObjectUrl) {
        URL.revokeObjectURL(previewObjectUrl);
        previewObjectUrl = '';
      }

      if (!file) {
        setFieldState('empty', 'Required: JPG or PNG.');
        return;
      }

      if (!validTypes.has(file.type) || !validExtensions.test(file.name)) {
        input.setCustomValidity('Please choose a JPG or PNG image.');
        setFieldState('invalid', 'JPG or PNG files only.');
        return;
      }

      setFieldState('checking', 'Checking image…');
      previewObjectUrl = URL.createObjectURL(file);
      const image = new Image();

      image.onload = () => {
        if (image.naturalHeight === image.naturalWidth) {
          input.setCustomValidity('');
          setFieldState('warning', file.name + ' — accepted. Square images may require cropping.', previewObjectUrl);
        } else {
          input.setCustomValidity('');
          const orientation = image.naturalHeight > image.naturalWidth ? 'portrait' : 'landscape';
          setFieldState('valid', file.name + ' — ready (' + orientation + ')', previewObjectUrl);
        }
      };

      image.onerror = () => {
        input.setCustomValidity('This image could not be read. Please choose another JPG or PNG file.');
        setFieldState('invalid', 'Unable to read this image. Please choose another file.');
        URL.revokeObjectURL(previewObjectUrl);
        previewObjectUrl = '';
      };

      image.src = previewObjectUrl;
    };

    const showValidation = () => {
      if (!input?.files?.length) input?.setCustomValidity('Please upload a JPG or PNG photograph.');
      if (authorization && !authorization.checked) {
        authorization.setCustomValidity('Please confirm that you have permission to reproduce this photograph.');
      }
      form.reportValidity();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    if (input) {
      input.dataset.photoValid = 'false';
      input.addEventListener('change', validateImage);
    }

    authorization?.addEventListener('change', () => {
      authorization.setCustomValidity('');
      updateAddButtons();
    });

    formComponent?.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('[name="add"], [ref="addToCartButton"]');
      if (!button || uploadReady()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showValidation();
    }, true);

    form.addEventListener('submit', (event) => {
      if (uploadReady()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showValidation();
    }, true);

    if (formComponent) {
      const observer = new MutationObserver(updateAddButtons);
      observer.observe(formComponent, { childList: true, subtree: true });
    }

    updateAddButtons();
  });
})();